<template>
  <div class="app-send-kwk-invitation" v-if="loaded_">
    <SimonModal
      :is-visible="showModal"
      @hide="showModal = false"
      id="kwk-invitation-info-modal-tabs"
      size="large"
    >
      <template v-slot:modalTitle>
        <h1><slot name="lblInfoTabsOverlay">Headline</slot></h1>
      </template>
            <b-tabs card pills align="center">
              <b-tab :title="lblInfoTabLeftOverlay" active>
                <b-card-text>
                  <div class="kwk-invitation-info">
                    <div class="item">
                      <div class="item--head">
                        <div class="item--num">1</div>
                        <div class="item--title"><slot name="lblItem1InfoOverlay">Title 1</slot></div>
                      </div>
                      <div class="item--body">
                        <div class="item--text"><slot name="txtItem1InfoOverlay">Text 1</slot></div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="item--head">
                        <div class="item--num">2</div>
                        <div class="item--title"><slot name="lblItem2InfoOverlay">Title 2</slot></div>
                      </div>
                      <div class="item--body">
                        <div class="item--text"><slot name="txtItem2InfoOverlay">Text 2</slot></div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="item--head">
                        <div class="item--num">3</div>
                        <div class="item--title"><slot name="lblItem3InfoOverlay">Title 3</slot></div>
                      </div>
                      <div class="item--body">
                        <div class="item--text"><slot name="txtItem3InfoOverlay">Text 3</slot></div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab :title="lblInfoTabRightOverlay">
                <b-card-text>
                  <p><slot name="txtInfoTabRightOverlay">Text rechts</slot></p>
                </b-card-text>
              </b-tab>
            </b-tabs>
    </SimonModal>

    <div class="kwk-invitation--head">
      <h4><slot name="lblHeadline">KWK</slot></h4>
      <div class="subline" v-if="!showError"><slot name="lblSubline">Einladungen verteilen</slot></div>
      <div class="info-link" @click="onClickModalLink()"><slot name="lblInfoLink">Weitere Infos & Bedingungen</slot></div>
    </div>
    <div class="kwk-invitation--cta" v-if="!showError">
      <button v-if="showKWKInviteCode" class="filled fluid white btn-invite code" @click="onClickShareCode()">
        <img src="/files/flash/images/svg-icons/icon-code.svg" width="33px" height="32px">
        <span>{{referralToken}}</span>
      </button>
      <button @click="onClickMobileButton()" class="filled fluid white btn-invite share">
        <img src="/files/flash/images/svg-icons/icon-invite.svg" width="39px" height="34px">
        <span><slot name="btnInvite">Jetzt einladen</slot></span>
      </button>
      <a :href="whatsappUrl" target="_blank“ rel=“noopener noreferrer"  @click="onClickWhatsapp()" class="button filled white btn-invite desktop">
        <img src="/files/flash/images/svg-icons/icon-whatsapp.svg" width="32px" height="29px">
        <span><slot name="btnWhatsapp">Whatsup</slot></span>
      </a>
      <a :href="mailToHref" class="button filled white btn-invite desktop" @click="onClickMail()">
        <img src="/files/flash/images/svg-icons/icon-email.svg" width="33px" height="32px">
        <span><slot name="btnEmail">Mail</slot></span>
      </a>
      <button class="filled white btn-invite desktop" @click="onClickShareLink()">
        <img src="/files/flash/images/svg-icons/icon-clipboard.svg" width="33px" height="32px">
        <span><slot name="btnClipboard">Clipboard</slot></span>
      </button>
    </div>
    <div class="kwk-invitation--cta__error" v-else>
      <div v-html="errorMsg" class="error-box"></div>
    </div>
    <div class="kwk-invitation--info" v-if="!showError">
      <div class="info-link" @click="onClickModalLink()"><slot name="lblInfoLink">Weitere Infos & Bedingungen</slot></div>
    </div>
  </div>
</template>

<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import syncProperty from '@/mixins/syncProperty'
import SimonModal from '@/components/modal/SimonModal.vue'
import useFeature from '@/mixins/useFeature'

export default {
  name: 'SendKWKInvitation',
  mixins: [
    syncProperty('invitationLoaded', 'loaded_'),
    useFeature('showKWKInviteCode')
  ],
  components: { SimonModal },
  data () {
    return {
      showError: false,
      errorMsg: '',
      showModal: false,
      friendReferralLink: {
        referralLink: null,
        referralToken: null
      }
    }
  },
  props: {
    shareLink: {
      type: String,
      default: ''
    }
  },
  mounted () {},
  computed: {
    mailToHref () {
      let ret = 'mailto:?subject=' + encodeURIComponent(this.getSlotText('lblMailSubject', 'Mail-Subject'))
      ret += '&body=' + encodeURIComponent(this.getSlotText('txtMailInvite', 'Mail-Text').split('[NL]').join('\n'))
      ret += ' %0A%0A' + encodeURIComponent(this.finalShareLink) + '%0A%0A'
      return ret
    },

    whatsappUrl () {
      return 'https://api.whatsapp.com/send?text=' + encodeURIComponent(this.getSlotText('txtWhatsappInvite', 'Whatsapp-Text')) + encodeURIComponent('\r\n') + encodeURIComponent(this.finalShareLink)
    },
    finalShareLink () {
      // return location.origin + this.shareLink + '?kwktoken=' + this.friendReferralLink?.referralToken || 'dummytoken'
      return this.friendReferralLink?.referralLink || 'dummyLink'
    },
    referralToken () {
      return this.friendReferralLink?.referralToken || ''
    },
    lblInfoTabLeftOverlay () {
      return this.getSlotText('lblInfoTabLeftOverlay')
    },
    lblInfoTabRightOverlay () {
      return this.getSlotText('lblInfoTabRightOverlay')
    }
  },
  methods: {
    copy (data, toastSlot) {
      try {
        navigator.clipboard.writeText(data)
        this.successToast(this.getSlotText(toastSlot, 'Die Daten wurden in die Zwischenablage kopiert!'))
      } catch (err) {
        this.errorToast(this.getSlotText('txtCopyErrorToast', 'Hoppla, da ist was schief gelaufen!'))
      }
    },
    onClickMail () {
      const data = {
        information_action: 'share',
        information_name: 'freunde einladen',
        information_ui_type: 'e-mail icon',
        information_trigger: 'button'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    onClickMobileButton () {
      this.share()
      const data = {
        information_action: 'share',
        information_name: 'freunde einladen',
        information_ui_type: 'app icon',
        information_trigger: 'button'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    onClickWhatsapp () {
      const data = {
        information_action: 'share',
        information_name: 'freunde einladen',
        information_ui_type: 'whatsapp icon',
        information_trigger: 'button'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    onClickShareCode () {
      this.copy(this.referralToken, 'txtCopyCodeSuccessToast')
      const data = {
        information_action: 'share',
        information_name: 'freunde einladen',
        information_ui_type: 'copy code icon',
        information_trigger: 'button'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    onClickShareLink () {
      this.copy(this.finalShareLink, 'txtCopySuccessToast')
      const data = {
        information_action: 'share',
        information_name: 'freunde einladen',
        information_ui_type: 'copy icon',
        information_trigger: 'button'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    onClickModalLink () {
      this.showModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'freunde einladen',
        information_ui_type: 'overlay',
        information_trigger: 'link'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    async share () {
      try {
        const shareData = {
          text: this.getSlotText('lblShareTitle', 'Freunde einladen!') + '\n\n' + this.getSlotText('txtShareInvite', 'Einladungstext') + '\n\n' + this.finalShareLink
        }
        // Webview Handling
        if (window.App !== undefined && window.App.share !== undefined) {
          if (window.isIOS !== 'undefined' && window.isIOS === true) {
            window.webkit.messageHandlers.share.postMessage(JSON.stringify(shareData))
          } else {
            window.App.share(JSON.stringify(shareData))
          }
        } else {
          // Default share function
          await navigator.share(shareData)
        }
      } catch (err) {
        const data = {
          type: 'technical',
          message: 'KWK share function failed'
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }
      }
    }
  },
  apollo: {
    friendReferralLink: function () {
      return wrapQuery(
        gql`query friendReferralLink{
          friendReferralLink {
            referralLink
            referralToken
          }
        }
        `, this, 'friendReferralLink', {}, () => {
          this.loaded_ = true
          this.$emit('loaded')
        },
        { fetchPolicy: 'no-cache' },
        (error) => {
          splitError(error).forEach(e => {
            this.errorMsg = e.message
          })
          if (!this.showError) {
            const data = {
              type: 'technical',
              message: this.errorMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.showError = true
          this.loaded_ = true
          this.$emit('loaded')
        }
      )
    }
  }
}
</script>
